export default "__VITE_ASSET__BVir$mF6__"